<template>
  <div>
    <user-table v-show="activeKey===1" ref="list" @add="add" @edit="edit" @enable="enable"/>
    <user-detail v-show="activeKey===2" ref="detail" @back="back"/>
  </div>
</template>

<script>
import UserTable from '@/views/basedata/user/UserTable.vue'
import UserDetail from '@/views/basedata/user/UserDetail.vue'

export default {
  name: 'UserBaseData',
  components: { UserTable, UserDetail },
  data() {
    return {
      activeKey: 1
    }
  },
  methods: {
    back() {
      this.activeKey = 1
      this.$refs.list.fetch()
    },
    add() {
      this.activeKey = 2
      this.$refs.detail.add()
    },
    edit(row) {
      this.activeKey = 2
      this.$refs.detail.fetch(row.id)
    },
    enable(row, available) {
      this.$refs.detail.enable(row, available)
    }
  }
}
</script>